import { render, staticRenderFns } from "./TheTomografia.vue?vue&type=template&id=b6dd6176&scoped=true&"
import script from "./TheTomografia.vue?vue&type=script&lang=js&"
export * from "./TheTomografia.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./TheTomografia.vue?vue&type=style&index=1&id=b6dd6176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6dd6176",
  null
  
)

export default component.exports